import {Campaign} from '@/types/campaign';
import {Identity} from '@/types/identity';

/**
 * Finds the identity that matches the campaign's network.
 * Matches by checking if the identity's provider or socialNetwork.name
 * corresponds to the campaign's network.
 */
function findMatchingIdentity(
  campaign: Campaign | null | undefined,
  identities: Identity[] | null | undefined
): Identity | null {
  if (!campaign?.network || !identities || identities.length === 0) {
    return null;
  }

  const campaignNetwork = campaign.network.toLowerCase();

  // First, try to match by socialNetwork.name
  const matchBySocialNetwork = identities.find((identity) => {
    const socialNetworkName = identity.socialNetwork?.name?.toLowerCase();
    return socialNetworkName === campaignNetwork;
  });

  if (matchBySocialNetwork) {
    return matchBySocialNetwork;
  }

  const matchByProvider = identities.find((identity) => {
    const provider = identity.provider?.toLowerCase() || '';

    if (provider === campaignNetwork) {
      return true;
    }

    const basePlatforms = [
      'instagram',
      'tiktok',
      'pinterest',
      'facebook',
      'youtube',
      'twitter',
    ];
    const campaignBase = basePlatforms.find((base) =>
      campaignNetwork.includes(base)
    );
    const providerBase = basePlatforms.find((base) => provider.includes(base));

    return campaignBase && providerBase && campaignBase === providerBase;
  });

  return matchByProvider || null;
}

export default findMatchingIdentity;
